<div class="card" *appIsGranted="['TOOLS_MAPS_AUX', 'TOOLS_MAPS_AUX', 'READ']">
  <div class="card-header">
    <div class="row">
      <ng-container *ngIf="mapSelect == 1">
        <div class="col-md-4"><h6>Mapas auxiliares</h6></div>
        <div class="col-md-4">
          <button
            class="btn btn-sm btn-success"
            (click)="openCoverageMapLorawan()"
          >
            Mapa de cobertura <br />EveryNet
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="mapSelect != 1">
        <div class="col-md-8"><h6>Mapas auxiliares</h6></div>
      </ng-container>
      <div class="col-md-4">
        <ng-select
          class="w-50 mb-3"
          id="mapSelect"
          placeholder="Selecione o mapa"
          [(ngModel)]="mapSelect"
          (change)="changeMap()"
        >
          <ng-option [value]="0"> P2P Denox </ng-option>
          <ng-option [value]="1"> Torres LoRaWAN </ng-option>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-4">
        <label>Filtro de tempo</label>
        <ng-select
          class="w-50 mb-3"
          id="filterTimeSelect"
          placeholder="Selecione um tempo"
          [(ngModel)]="filterTimeHeatMap"
        >
          <ng-container *ngIf="mapSelect == 1">
            <ng-option [value]="-1"> Sem filtro</ng-option>
          </ng-container>
          <ng-option [value]="86400"> 1 dia </ng-option>
          <ng-option [value]="86400 * 2"> 2 dias </ng-option>
          <ng-option [value]="86400 * 3"> 3 dias </ng-option>
          <ng-option [value]="86400 * 4"> 4 dias </ng-option>
          <ng-option [value]="86400 * 5"> 5 dias </ng-option>
          <ng-option [value]="86400 * 6"> 6 dias </ng-option>
          <ng-option [value]="86400 * 7"> 7 dias </ng-option>
        </ng-select>
        <ng-container *ngIf="mapSelect == 1">
          <label>Raio (m)</label>
        </ng-container>
        <ng-container *ngIf="mapSelect == 0">
          <label>Pesos</label>
        </ng-container>
        <ui-switch
          #flagWeightRadius
          class="ms-2"
          defaultBgColor="#F44336"
          defaultBoColor="#dfdfdf"
          color="#038edc"
          checkedLabel="True"
          [ngbTooltip]="
            mapSelect == 1
              ? 'Mostra o raio com base na última posicao da torre (distancia entre o gps do dispositivo e a torre'
              : null
          "
          [checked]="mapSelect == 0 ? true : false"
          uncheckedLabel="False"
          (change)="
            mapSelect == 0
              ? changeWeight(flagWeightRadius)
              : mapSelect == 1
              ? changeRadius(flagWeightRadius)
              : null
          "
        ></ui-switch>
        <ng-container *ngIf="mapSelect == 0">
          <button
            class="btn btn-sm btn-primary"
            (click)="changeGradient()"
            [disabled]="heatMapP2PDenoxItem.length == 0"
          >
            Alterar gradiente de cor
          </button>
        </ng-container>
      </div>
      <ng-container
        *ngIf="markerMapTowerLoRaWAN.length > 0 || heatMapP2PDenox.length > 0"
      >
        <div class="col-md-4">
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text">UF</span>
            <ng-select class="w-50" placeholder="UF" (change)="getCity($event)">
              <ng-option *ngFor="let uf of ufLst">
                {{ uf }}
              </ng-option>
            </ng-select>
          </div>
          <div *ngIf="!circularProgressiveCity && cityLst.length > 0">
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text">Municipio</span>
              <ng-select
                class="w-75"
                placeholder="Selecione uma cidade"
                (change)="changeMapOnChangeCity($event)"
              >
                <ng-option *ngFor="let city of cityLst" [value]="city.name">
                  {{ city.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="col-md-2">
        <button class="btn btn-sm btn-primary m-3" (click)="geHeatMapData()">
          Pesquisar
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <ng-container *ngIf="circularProgressiveWait || circularProgressiveCity">
      <div class="card align-items-center">
        <div card="card-body mt-n3">
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </ng-container>
    <div>
      <div class="card m-3" style="max-width: fit-content">
        <h6 class="m-2">Contagem dos valores: {{ countValues }}</h6>
      </div>
      <div class="card align-items-center" *ngIf="!maps">
        <div card="card-body mt-n3">
          <p>Carregando o mapa</p>
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div id="map" [minHeight]="500" [fluidHeight]></div>
    </div>
  </div>
</div>
